import React from 'react';
import { twMerge } from 'tailwind-merge';
import { NewIconProps } from '@diritto/common/style/icon';

interface CardViewIconProps extends NewIconProps {
  color?: string;
}

export const CardViewIcon = ({ className, color = '#32383F' }: CardViewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="4.49976" y="4.49951" width="5.00041" height="5.00041" rx="0.571467" fill={color} />
    <rect x="4.49976" y="10.5" width="5.00041" height="5.00041" rx="0.571467" fill={color} />
    <rect x="10.4998" y="4.49951" width="5.00041" height="5.00041" rx="0.571467" fill={color} />
    <rect x="10.4998" y="10.5" width="5.00041" height="5.00041" rx="0.571467" fill={color} />
  </svg>
);
